SP.StoreMapper = Garnish.Base.extend({
    init() {
        let checkboxes = $('.storemapper-categories .checkbox input')
        this.addListener(checkboxes, 'change', this.handleCheckbox)
    },

    handleCheckbox(e) {
        let $input = $(e.target)
        let $label = $input.parent()
        let filterName = $input.parent().text()

        if ($input.is(':checked')) {
            $label.addClass('checked')
        } else {
            $label.removeClass('checked')
        }
    }
})


SP.StoreMapperScripts = Garnish.Base.extend({
    $container: null,
    $checkboxes: null,

    init() {
        let self = this
        this.$container = $('#storemapper')
        this.$checkboxes = this.$container.find('.checkbox')
        console.log('Storemapper loaded')


        $('.storemapper-categories .checkbox input').on('change', function (e) {

            if ($(this).hasClass('storemapper-select-all')) {
                if ($(this).is(':checked')) {
                    $('.storemapper-categories .checkbox').addClass('checked')
                } else {
                    $('.storemapper-categories .checkbox').removeClass('checked')
                }
            } else {
                if ($(this).is(':checked')) {
                    $(this).parent().addClass('checked')
                } else {
                    $(this).parent().removeClass('checked')
                }
            }
        })
    },

    handleCheckboxClick() {
        console.log('check box clicked')
    }
})